var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "custom-box",
    {
      staticStyle: { "pointer-events": "auto" },
      attrs: {
        title: "问卷答题详情",
        visible: _vm.dialogFormVisible,
        "close-on-click-modal": false,
        "modal-append-to-body": true,
        modal: false
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogFormVisible = $event
        }
      }
    },
    [
      _c("div", { staticClass: "answer-detail-container" }, [
        _c(
          "div",
          { staticClass: "questions-scroll-box" },
          _vm._l(_vm.questionResult, function(item, index) {
            return _c(
              "div",
              { key: item.question_id, staticClass: "question-item-card" },
              [
                _c("div", { staticClass: "q-header" }, [
                  _c(
                    "span",
                    {
                      staticClass: "q-badge",
                      class: item.type === 1 ? "badge-select" : "badge-text"
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(item.type === 1 ? "选择题" : "填空题") +
                          " "
                      )
                    ]
                  ),
                  _c("span", { staticClass: "q-title" }, [
                    _vm._v(_vm._s(index + 1) + ". " + _vm._s(item.title))
                  ]),
                  item.required
                    ? _c("span", { staticClass: "q-required-tag" }, [
                        _vm._v("* 必填")
                      ])
                    : _vm._e()
                ]),
                item.type === 1
                  ? _c(
                      "div",
                      { staticClass: "options-container" },
                      _vm._l(item.options, function(opt) {
                        return _c(
                          "div",
                          {
                            key: opt.id,
                            staticClass: "option-row",
                            class: {
                              "is-checked": _vm.isOptionChecked(
                                item.answer,
                                opt.id
                              )
                            }
                          },
                          [
                            _c("span", { staticClass: "check-icon" }, [
                              _vm.isOptionChecked(item.answer, opt.id)
                                ? _c("i", { staticClass: "el-icon-check" })
                                : _vm._e()
                            ]),
                            _c("span", { staticClass: "option-text" }, [
                              _vm._v(_vm._s(opt.desc))
                            ]),
                            _vm.isOptionChecked(item.answer, opt.id) &&
                            _vm.getOptionInputValue(item.answer, opt.id)
                              ? _c("el-input", {
                                  staticClass: "other-input-inline",
                                  attrs: {
                                    size: "mini",
                                    value: _vm.getOptionInputValue(
                                      item.answer,
                                      opt.id
                                    ),
                                    disabled: ""
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      }),
                      0
                    )
                  : item.type === 2
                  ? _c("div", { staticClass: "text-answer-container" }, [
                      _c("div", { staticClass: "text-answer-box" }, [
                        _c("span", { staticClass: "text-label" }, [
                          _vm._v("玩家回复：")
                        ]),
                        _c("div", { staticClass: "text-content" }, [
                          _vm._v(_vm._s(item.answer || "（未填写）"))
                        ])
                      ])
                    ])
                  : _vm._e()
              ]
            )
          }),
          0
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }